/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepairOrderRequestLine
 */
export interface RepairOrderRequestLine {
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequestLine
     */
    line: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequestLine
     */
    uniqueSequenceNum?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequestLine
     */
    operation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequestLine
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequestLine
     */
    partNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequestLine
     */
    quantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequestLine
     */
    extendedPrice?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOrderRequestLine
     */
    laborIncluded?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrderRequestLine
     */
    labor?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequestLine
     */
    laborType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequestLine
     */
    partType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrderRequestLine
     */
    sectionHeader?: string | null;
}

/**
 * Check if a given object implements the RepairOrderRequestLine interface.
 */
export function instanceOfRepairOrderRequestLine(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "line" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function RepairOrderRequestLineFromJSON(json: any): RepairOrderRequestLine {
    return RepairOrderRequestLineFromJSONTyped(json, false);
}

export function RepairOrderRequestLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepairOrderRequestLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'line': json['line'],
        'uniqueSequenceNum': !exists(json, 'uniqueSequenceNum') ? undefined : json['uniqueSequenceNum'],
        'operation': !exists(json, 'operation') ? undefined : json['operation'],
        'description': json['description'],
        'partNumber': !exists(json, 'partNumber') ? undefined : json['partNumber'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'extendedPrice': !exists(json, 'extendedPrice') ? undefined : json['extendedPrice'],
        'laborIncluded': !exists(json, 'laborIncluded') ? undefined : json['laborIncluded'],
        'labor': !exists(json, 'labor') ? undefined : json['labor'],
        'laborType': !exists(json, 'laborType') ? undefined : json['laborType'],
        'partType': !exists(json, 'partType') ? undefined : json['partType'],
        'sectionHeader': !exists(json, 'sectionHeader') ? undefined : json['sectionHeader'],
    };
}

export function RepairOrderRequestLineToJSON(value?: RepairOrderRequestLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'line': value.line,
        'uniqueSequenceNum': value.uniqueSequenceNum,
        'operation': value.operation,
        'description': value.description,
        'partNumber': value.partNumber,
        'quantity': value.quantity,
        'extendedPrice': value.extendedPrice,
        'laborIncluded': value.laborIncluded,
        'labor': value.labor,
        'laborType': value.laborType,
        'partType': value.partType,
        'sectionHeader': value.sectionHeader,
    };
}

